import { Metamodel } from '../base/model';
import { SalesforceV2Sink } from './salesforce-v2.copysink';
import { SalesforceServiceCloudV2Dataset } from '../dataset/salesforce-service-cloud-v2.dataset';
import { ModelConstants } from '../model-constants';

@Metamodel.model({
    name: ModelConstants.salesforceServiceCloudV2CopySink,
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(SalesforceServiceCloudV2Dataset) }
})
export class SalesforceServiceCloudV2Sink extends SalesforceV2Sink {
}
